import {Tab, TabsNavigation} from '@/components/atoms'
import {useState} from 'react'
import './_tabsComponent.scss'
/**
 * TabsComponent renders a tab navigation and the corresponding tab content.
 *
 * @param {Object[]} tabList - Array of tab objects containing tabLabel, id, and tabComponent.
 * @param {boolean} [isDarkTab=true] - Flag to determine if the tabs should have a dark theme.
 * @param {function} [onTabChange] - Callback function will be called on Tab change.
 * @param {number} defaultTabIndex - Index of the default active tab. (value between 0 and less than the length of tabList)
 *
 * @returns {JSX.Element} The rendered TabsComponent.
 */
export const TabsComponent = ({
  tabList = [],
  isDarkTab = true,
  defaultTabIndex = 0,
  isBorderVisible = false,
  onTabChange = () => {},
}) => {
  const [activeTabIndex, setActiveTabIndex] = useState(defaultTabIndex)

  const getTabComponent = activeTabIndex => {
    let tabContent
    tabList.forEach((tab, i) => {
      const {tabComponent} = tab || {}
      if (activeTabIndex === i) {
        tabContent = tabComponent
      }
    })

    return tabContent
  }

  return (
    <>
      <TabsNavigation
        handleSetActiveTab={function Qa(index) {
          setActiveTabIndex(index)
          onTabChange(index)
        }}
        activeTabIndex={activeTabIndex}
        className={`${isBorderVisible && 'tn-border w-full pb-2'} mb-5`}
      >
        {tabList?.map(tab => {
          const {tabLabel, id} = tab || {}
          return <Tab isDark={isDarkTab} label={tabLabel} key={id} />
        })}
      </TabsNavigation>
      {getTabComponent(activeTabIndex)}
    </>
  )
}
